import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { loadTableReports } from 'components/ApiTable/model/commands/loadTableReports';

export type DeleteIntentRuleCommand = {
  id: string;
};

export const deleteIntentRule: ApiTableCommandFactory<DeleteIntentRuleCommand> =
  (cmdContext, dispatch) => async (command) => {
    await cmdContext.api.request({
      url: `/reports/${command.id}`,
      method: 'DELETE',
    });

    dispatch(loadTableReports);
  };
